"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntryUrl = void 0;
const getEntryUrl = (state = {}) => state.entryUrl || '';
exports.getEntryUrl = getEntryUrl;
//# sourceMappingURL=entryUrl.js.map